import React, { Component } from 'react';

class SimpleButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
      isClicked: false,
    };
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
  };

  handleClick = (e) => {
    
    e.stopPropagation();
    const { name, onClick } = this.props;
    
    this.setState({ isClicked: true }, () => {
      // Réinitialise l'état après l'animation
      setTimeout(() => this.setState({ isClicked: false }), 200);
    });
    if (onClick) {
      onClick(name, e.shiftKey);
    }
  };

  render() {
    const { image, name, size = 50 } = this.props;
    const { isHovered, isClicked } = this.state;

    

    const buttonSize = isClicked ? size * 0.9 : isHovered ? size * 1.1 : size;

    const buttonStyle = {
      position: "absolute",
      width: `${buttonSize}px`,
      height: `${buttonSize}px`,
      backgroundImage: `url(${image})`,
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      border: 'none',
      cursor: 'pointer',
      transition: 'transform 0.2s ease',
      backgroundColor: 'transparent',
    };

    if ("top" in this.props) buttonStyle.top = this.props.top;
    if ("left" in this.props) buttonStyle.left = this.props.left;
    if ("right" in this.props) buttonStyle.right = this.props.right;
    if ("bottom" in this.props) buttonStyle.bottom = this.props.bottom;

    return (
      <button
        style={buttonStyle}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onMouseDown={e=>{this.handleClick(e)}}
        aria-label={name}
      />
    );
  }
}

SimpleButton.defaultProps = {
    size: 16,
}

export default SimpleButton;